import React, { useEffect, useState } from "react";
import Footer1 from "components/Footer1";
import Header from "components/Header";
import InfoRibbon from "components/InfoRibbon";
import { useNavigate } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import { MoreProducts } from "../../components/MoreProducts";
import { clearSearchKeyword } from "../../states/search.mjs";

const ProductsPagePage = () => {
  const navigate = useNavigate();
  // const [category, setCategory] = useState(undefined);

  useEffect(() => {
    // const categoryFilter = new URLSearchParams(window.location.search).get("category");
    // setCategory(categoryFilter??'');
    return () => {
      clearSearchKeyword();
    };
  }, []);

  return (
    <>
      <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
        <InfoRibbon className="bg-deep_purple-900 flex flex-row md:gap-10 items-center justify-between p-3 w-full" />
        <Header />
        {/*<ContextMenu />*/}
        <MoreProducts
          onAddToBasket={(element) => {
            // addToCart(element, 1);
            // toast.success(`${element?.product} added to cart`);
            navigate("/productdetailpage", {
              state: { ...element ?? {} }
            });
          }}
          onSelect={(element) => {
            navigate("/productdetailpage", {
              state: { ...element ?? {} }
            });
          }}
        />
        <Footer1 className="bg-blue_gray-900 flex items-center justify-center pt-[98px] md:px-5 w-full" />
      </div>
    </>
  );
};

export default ProductsPagePage;
